import { render, staticRenderFns } from "./FormLoginMobile.vue?vue&type=template&id=b2b35e14&scoped=true&"
import script from "./FormLoginMobile.vue?vue&type=script&lang=js&"
export * from "./FormLoginMobile.vue?vue&type=script&lang=js&"
import style0 from "./FormLoginMobile.vue?vue&type=style&index=0&id=b2b35e14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b35e14",
  null
  
)

export default component.exports